/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentAnalyzeMonitorReviewsAssignedConversationDetailsRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.reviews.assigned.conversation.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentAnalyzeMonitorReviewsAssignedConversationDetailsRoute);
